<div class="pickup-for-hero">
    <div class="pickup-for-hero__inner">

        <div class="pickup-for-hero__hd">
            <shared-header class="pickup-for-hero__pre-header" [brandAccent]="true" type="5" marginTop="xs"
                marginBottom="none">{{preHead}}</shared-header>
            <shared-header class="pickup-for-hero__header" [inverted]="true" type="1" marginTop="xs" marginBottom="xs">
                <span class="pickup-for-hero__title" [innerHtml]="title | nlOnWords: 'order?'"></span>
                <div class="pickup-for-hero__bd" [ngClass]="{'is-disabled': !(hasLocations$ | async)}"
                    *ngIf="!(isBelowDrawerMediaBreakpoint$ | async)">
                    <div class="pickup-for-hero__content">
                        <shared-pickup-asap class="pickup-for-hero__btn-element" [disabled]="!(hasLocations$ | async)"
                            [isActive]="(currentMode$ | async)?.Id === 1" (onClick)="onAsapClick($event)"
                            [title]="asapTitle" [mode]="mode">
                        </shared-pickup-asap>

                        <div class="pickup-for-hero__collapse">
                            <div class="pickup-for-hero__select">
                                <span class="pickup-for-hero__separator">/</span>

                                <div class="pickup-for-hero__options">
                                    <shared-pickup-later [labelType]="pickupLabelType"
                                        class="pickup-for-hero__btn-element" [isSchedule]="futureOrders"
                                        [disabled]="!(hasLocations$ | async)"
                                        [isActive]="(currentMode$ | async)?.Id === 2"
                                        (onDropdownToggle)="dropdownToggle($event)"
                                        (onDropdownSelected)="dropdownSelected($event)" [title]="laterTitle"
                                        [mode]="mode" [selected]="selected$ | async" [options]="options$ | async"
                                        [dropdownWidth]="dropdownWidth">
                                    </shared-pickup-later>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>


            </shared-header>
        </div>
    </div>
</div>